export default __webpack_public_path__ + "static/31427-97f59547062b56bf353dbfdb6f7611d0.jpg";